<template>
  <el-dropdown
    placement="bottom"
    @command="handleCommand"
  >
    <el-avatar
      icon="el-icon-user-solid"
      class="my-avatar"
    ></el-avatar>
    <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-user-solid" :disabled="true">{{userName}}</el-dropdown-item>
        <!--<el-dropdown-item command="index" icon="el-icon-coordinate">学员端</el-dropdown-item>-->
        <el-dropdown-item command="logout" icon="el-icon-setting">退出</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
export default {
  data() {
    return {
      userName: "",
    };
  },
  methods: {
    //头像下拉框操作
    handleCommand(command) {
      switch (command) {
        case "logout":
          //退出
          window.sessionStorage.clear();
          this.$store.commit("saveToken", "");
          this.$Cookies.remove(process.env.VUE_APP_COOKIES);
          let to =window.location.protocol +"//" +window.location.host +(window.location.pathname == "/" ? "/" : window.location.pathname) +"#/Admin/Index"; //这里重定向要加后面/#/
		  window.location.href = process.env.VUE_APP_LOGIN_URL + "login?RedirectUrl=" + encodeURIComponent(to) + "&sysid=" + process.env.VUE_APP_SYSID;
          break;
          case "index":
          window.location.href = process.env.VUE_APP_WEBBASEURL;
          break;
        default:
          break;
      }
    },
    getUserInfo() {
      let _this = this;
      _this.$api.get(
        "/Main/GetUserInfo",
        null,
        function (res) {
          if (res.code == 200) {
            _this.userName = res.data[0].usercname;
          }
        },
        function (res) { },
        true
      );
    },
  },
  created() {
    this.getUserInfo();
  },
};
</script>
<style lang="less" scoped>
.my-avatar {
  cursor: pointer;
  height: 30px;
  width: 30px;
  line-height: 30px;
  color: #35b8f3;
  background: #fff;
}
</style>
